export function getId(url: string): string | null {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)

  return match && match[2].length === 11 ? match[2] : null
}

export const convertYouTubeToEmbed = (link: string) => {
  const videoId = getId(link)
  if (videoId) {
    return `//www.youtube.com/embed/${videoId}?enablejsapi=1&version=3&playerapiid=ytplayer`
  }
  return link
}

export const embedClassName = (link: string) => {
  const videoId = getId(link)
  if (videoId) {
    return `youtube-player aspect-video`
  }
  if (link && link.includes('matterport')) {
    return 'matterport'
  }
  return 'unknown'
}
